import {
  DashboardCreateRequest,
  DashboardInputs,
  DashboardUpdateRequest,
} from '../../../types/app/dashboards.types';

export const convertDataFromInputToCreateRequest = (
  data: DashboardInputs,
): DashboardCreateRequest => ({
  assetId: data.assetId,
  type: data.type,
  name: data.name,
  url: data.url,
  assetType: data.assetType,
});

export const convertDataFromInputToUpdateRequest = (
  data: DashboardInputs,
): DashboardUpdateRequest => ({
  id: data.id,
  assetId: data.assetId,
  name: data.name,
  url: data.url,
  assetType: data.assetType,
});
